import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["successIcon", "errorIcon"]
  }

  static get values() {
    return {
      url: String,
      attribute: String,
    }
  }

  connect() {
    this.originalValue = this.element.innerText.trim()
    this.originalNodeHtml = this.element.innerHTML

    if (this.hasSuccessIconTarget) {
      setTimeout(() => {
        this.successIconTarget.classList.add("is-hidden")
      }, 3000)
    }
  }

  startEditing() {
    if (this.hasSuccessIconTarget) {
      this.successIconTarget.classList.add("d-none")
    }
    if (this.hasErrorIconTarget) {
      this.errorIconTarget.classList.add("d-none")
    }
    this.element.classList.add("h-data-table-cell--editing")
    this.element.setAttribute("contenteditable", "true")
    this.element.innerText = this.originalValue
    this.element.focus()

    // Move cursor to end of contenteditable element
    const range = document.createRange()
    const selection = window.getSelection()
    range.selectNodeContents(this.element)
    range.collapse(false) // false collapses to end
    selection.removeAllRanges()
    selection.addRange(range)
  }

  save(event) {
    const newValue = this.element.innerText.trim()

    if (newValue === this.originalValue) {
      this.cancel()
      this.element.innerHTML = this.originalNodeHtml
      if (this.hasSuccessIconTarget) {
        this.successIconTarget.classList.add("d-none")
      }
      return
    }

    // If user just focuses out of the cell, we don't want to save the value since it may be empty by accident
    // (for example "website" once started editing, the value is empty, user focuses out, and we save it)
    if (newValue.length === 0 && event && (event.type === "blur" || event.type === "focusout")) {
      this.cancel()
      this.element.innerHTML = this.originalNodeHtml
      if (this.hasSuccessIconTarget) {
        this.successIconTarget.classList.add("d-none")
      }
      return
    }

    const data = new FormData()
    if (this.attributeValue.startsWith("custom_attribute-")) {
      data.append(`lead[custom_attributes][${this.attributeValue.split("-")[1]}]`, newValue)
    } else {
      data.append(`lead[${this.attributeValue}]`, newValue)
    }

    fetch(this.urlValue, {
      method: "PUT",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
        Accept: "application/json",
      },
      body: data,
    })
      .then((response) => response.json())
      .then((data) => {
        let turboStream = data.turbo_stream

        if (data.success) {
          if (turboStream) {
            Turbo.renderStreamMessage(turboStream)
          }
        } else {
          // Handle error
          if (turboStream) {
            Turbo.renderStreamMessage(turboStream)
          }
        }
      })
      .catch(() => {
        App.displayFlash("danger", "Failed to update")
      })
  }

  cancel() {
    this.element.textContent = this.originalValue
    this.element.classList.remove("h-data-table-cell--editing")
    this.element.removeAttribute("contenteditable")
    this.element.blur()
  }

  handleKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.save()
    } else if (event.key === "Escape") {
      event.preventDefault()
      this.cancel()
    }
  }

  handlePaste(e) {
    e.preventDefault()

    const plainText = e.clipboardData.getData("text/plain")
    this.element.innerText = plainText
  }
}
